<template>
  <div class="dl-container">
    <slot />
  </div>
</template>

<script lang="ts" src="./dl-container.ts"></script>

<style lang="scss" scoped src="./dl-container.scss"></style>
